import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from "../carrier/response-container";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';
import { PrintRequest } from "../carrier/print-request";
import { Carrier } from "../carrier/carrier";
import { timeout, tap } from 'rxjs/operators';

@Injectable()
export class TubeSearchService {

    defaultTimeout = 600000;

    constructor(private http: HttpClient) { }

    /**
   * @function
   * @param lab
   * @param startPage
   * @param tubeBarcode
   * @description Make service call to get searched tube carriers for given lab and given tube barcode
   * this call always brings defined number of records for given page index (start page) as
   * part of lazy loading
   * this call supports partial(like search) and full search of tube barcodes
  */
    getTubeCarriers(startPage: number, tubeBarcode: string): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/sample/'+tubeBarcode;
        let requestParam = new HttpParams().set('startPage', startPage.toString())
                                          .set('barcode', tubeBarcode);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
          error.url = url;
        }));
      }

       /**
   * @function
   * @param lab
   * @param tubeBarcode
   * @description Make service call to get Total count searched tube carriers for given lab and 
   * given tube barcode, this count is used for lazy loading to fectch the records in multiple calls
   * this call supports partial(like search) and full search of tube barcodes
  */
      getTubeCarriersCount(tubeBarcode: string): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/sample/'+tubeBarcode+'/count';
        let requestParam = new HttpParams().set('barcode', tubeBarcode);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
          error.url = url;
        }));
      }

    //for Lab change emit from app.component.ts
    private emitChangeSource = new Subject<any>();
    changeEmitted$ = this.emitChangeSource.asObservable();
    emitChange(change: any) {
    this.emitChangeSource.next(change);
    }

    public reprintLabel(printRequest: PrintRequest): Observable<BBResponseContainer> {
      let url = environment.BB_PRINT_SERVICE_URL + 'printLabel';
      return this.http.post<BBResponseContainer>(url, printRequest).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
          error.url = url;
      }));
  }

  public reExport(carrier: Carrier): Observable<BBResponseContainer> {

      let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'generateControllerFile';
      return this.http.post<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
          error.url = url;
      }));

  }
                
}